/**
 *  CookieConsentModal Component
 */

import './styles.scss';

import { WithRouter, withRouter } from 'found';
import * as React from 'react';
import * as BEM from 'react-bem-helper';

import { CookieContext } from '../../../../contexts/cookie';
import { ICookieContext } from '../../../../contexts/cookie/types';
import Button from '../../../atoms/buttons/Button';
import Heading from '../../../atoms/text/Heading';
import * as Modal from '../ModalBase';

interface ICookieContextProps {
  cookieConsentContext: ICookieContext;
}

type CookieConsentModalProps =
  & ICookieContextProps
  & WithRouter;

// tslint:disable-next-line:no-empty-interface
interface IOwnState {
}

enum ModalAction {
  OK = 'ok',
  PrivacyPolicy = 'privacy_policy',
}

const classes = new BEM('cookie-consent-modal');

class CookieConsentModalBase extends React.Component<CookieConsentModalProps, IOwnState> {

  constructor(props) {
    super(props);
    this.state = {};
  }

  onModalClose: Modal.OnCloseModalHandler = (id) => {
    this.props.cookieConsentContext.clear();
  }

  render() {
    return (
      <Modal.Component
        actions={(
          <>
            <Modal.Action
              id={ModalAction.PrivacyPolicy}
              style="cancel"
              Element={(
                <Button
                  onClick={(e) => e.stopPropagation()}
                  hyperLinkProps={{
                    href: '/privacy-policy',
                    target: '_blank',
                  }}
                  wrapperComponent="a"
                  label="Privacy Policy"
                />
              )}
            />
            <Modal.DefaultAction
              id={ModalAction.OK}
              onClick={() => this.props.cookieConsentContext.handleConsent()}
              label="OK"
            />
          </>
        )}
        position={Modal.Position.Center}
        onClose={this.onModalClose}
        {...classes()}
      >
        <Modal.Content>
        <img width="50%" src="https://assets.boppermusic.com/images/cookies-256x220.png" alt="cookies" />
        <Heading is="h2">Cookies!</Heading>
        <Heading is="h4">We use cookies to make your experience&nbsp;better.</Heading>
        </Modal.Content>
      </Modal.Component>
    );
  }
}

const CookieConsentModalWithCookieContext: React.SFC<WithRouter> = (props) => (
  <CookieContext.Consumer>
    {(ctx) => !ctx.consentReceived ? (
      <CookieConsentModalBase
        cookieConsentContext={ctx}
        {...props}
      />
    ) : null}
  </CookieContext.Consumer>
);

export default withRouter<{}>(CookieConsentModalWithCookieContext);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/modals/CookieConsentModal/index.tsx